(() => {
  if (window.__licohennaDeliveryPreferenceBound) return;
  window.__licohennaDeliveryPreferenceBound = true;

  const DATE_KEY = '配送希望日';
  const TIME_KEY = '配送希望時間帯';
  const TIMEZONE = 'Asia/Tokyo';

  // Future extension: add closed days as 'YYYY-MM-DD' strings.
  // Example: ['2026-12-31', '2027-01-01']
  const EXCLUDED_DATES = [];

  const japanDateFormatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

  const getJapanTodayYmd = () => japanDateFormatter.format(new Date());

  const addDaysToYmd = (ymd, days) => {
    const [year, month, day] = ymd.split('-').map(Number);
    const date = new Date(Date.UTC(year, month - 1, day));
    date.setUTCDate(date.getUTCDate() + days);
    return date.toISOString().slice(0, 10);
  };

  const isExcludedDate = (ymd) => EXCLUDED_DATES.includes(ymd);

  const getRangeForRoot = (root) => {
    const minOffset = Number(root.dataset.minOffsetDays || 6);
    const maxOffset = Number(root.dataset.maxOffsetDays || 30);
    const today = getJapanTodayYmd();
    return {
      min: addDaysToYmd(today, minOffset),
      max: addDaysToYmd(today, maxOffset),
    };
  };

  const applyLimits = (root) => {
    const dateInput = root.querySelector('[data-delivery-date]');
    if (!dateInput) return;

    const { min, max } = getRangeForRoot(root);
    dateInput.min = min;
    dateInput.max = max;

    if (dateInput.value) {
      if (dateInput.value < min || dateInput.value > max || isExcludedDate(dateInput.value)) {
        // Keep previously saved values visible when still a calendar string,
        // but block newly invalid picks via min/max. Excluded dates clear on change.
        if (isExcludedDate(dateInput.value)) {
          dateInput.value = '';
        }
      }
    }
  };

  const initRoots = (scope = document) => {
    scope.querySelectorAll('[data-licohenna-delivery-preference]').forEach(applyLimits);
  };

  const updateAttributes = async (attributes) => {
    const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes }),
      keepalive: true,
    });

    if (!response.ok) {
      const text = await response.text().catch(() => '');
      throw new Error(`cart/update.js failed (${response.status}): ${text}`);
    }

    return response.json();
  };

  const syncAllRoots = (attributes) => {
    document.querySelectorAll('[data-licohenna-delivery-preference]').forEach((root) => {
      const dateInput = root.querySelector('[data-delivery-date]');
      const timeSelect = root.querySelector('[data-delivery-time]');
      if (dateInput && Object.prototype.hasOwnProperty.call(attributes, DATE_KEY)) {
        dateInput.value = attributes[DATE_KEY] || '';
        applyLimits(root);
      }
      if (timeSelect && Object.prototype.hasOwnProperty.call(attributes, TIME_KEY)) {
        timeSelect.value = attributes[TIME_KEY] || '';
      }
    });
  };

  const onFieldChange = async (event) => {
    const root = event.target.closest('[data-licohenna-delivery-preference]');
    if (!root) return;

    const dateInput = event.target.matches('[data-delivery-date]')
      ? event.target
      : root.querySelector('[data-delivery-date]');
    const timeSelect = event.target.matches('[data-delivery-time]')
      ? event.target
      : root.querySelector('[data-delivery-time]');

    if (!dateInput && !timeSelect) return;

    const { min, max } = getRangeForRoot(root);
    let dateValue = dateInput ? dateInput.value.trim() : '';
    let timeValue = timeSelect ? timeSelect.value.trim() : '';

    if (dateValue) {
      if (dateValue < min || dateValue > max || isExcludedDate(dateValue)) {
        console.error('[licohenna-delivery-preference] invalid date selected', {
          dateValue,
          min,
          max,
          excluded: isExcludedDate(dateValue),
        });
        dateInput.value = '';
        dateValue = '';
      }
    }

    // 「指定なし」は空文字として保存し、注文詳細に不要な値を残さない
    if (timeValue === '指定なし') {
      timeValue = '';
      if (timeSelect) timeSelect.value = '';
    }

    const attributes = {};
    if (event.target.matches('[data-delivery-date]')) {
      attributes[DATE_KEY] = dateValue;
    }
    if (event.target.matches('[data-delivery-time]')) {
      attributes[TIME_KEY] = timeValue;
    }

    if (Object.keys(attributes).length === 0) return;

    try {
      await updateAttributes(attributes);
      syncAllRoots(attributes);
    } catch (error) {
      console.error('[licohenna-delivery-preference] failed to save cart attributes', error);
    }
  };

  document.addEventListener('change', onFieldChange);
  document.addEventListener('cart-drawer:refreshed', () => initRoots());
  document.addEventListener('DOMContentLoaded', () => initRoots());

  if (document.readyState !== 'loading') {
    initRoots();
  }
})();
